module.exports = __webpack_public_path__ + "img/IT-Support.50a2d4b1.jpg";